"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breakdown = void 0;
const React = __importStar(require("react"));
const Fractions_1 = require("./Fractions");
const Legend_1 = require("./Legend");
const Breakdown = (props) => {
    return React.createElement("div", { className: `breakdown ${props.parts.length == 0 && 'hidden'}` },
        React.createElement(Legend_1.Legend, { parts: props.parts }),
        React.createElement(Fractions_1.Fractions, { fractions: props.parts, viewMode: props.viewMode }));
};
exports.Breakdown = Breakdown;
